import { graphql } from "generated/gql";

export const getAccessionScientificNamesDocument = graphql(/* GraphQL */ `
  query GetAccessionScientificNames(
    $last: Int
    $organisationSubdomain: String!
    $searchTerm: String
    $filter: ScientificNameFilter
    $orderBy: ScientificNameOrderBy
    $taxaSearchTerm: TaxaSearchTerm
    $taxaFilter: TaxaFilter
  ) {
    sharedScientificNames(
      last: $last
      searchTerm: $searchTerm
      filter: $filter
      orderBy: $orderBy
    ) {
      nodes {
        id
        scientificName
        authorship
        status
        rank
        nameSource
      }
    }
    org: organisationBySubdomain(subdomain: $organisationSubdomain) {
      result: taxa(
        last: $last
        searchTerm: $taxaSearchTerm
        filter: $taxaFilter
      ) {
        nodes {
          ...TaxaListFields
        }
      }
    }
  }
`);

export const getMultiRankScientificNamesDocument = graphql(/* GraphQL */ `
  query GetMultiRankScientificNames(
    $last: Int
    $generaSearchTerm: String
    $speciesSearchTerm: String
    $infraspeciesSearchTerm: String
    $orderBy: ScientificNameOrderBy
  ) {
    genera: sharedScientificNames(
      last: $last
      searchTerm: $generaSearchTerm
      filter: {rank: {eq: GENUS}}
      orderBy: $orderBy
    ) {
      nodes {
        id
        scientificName
        authorship
        status
        rank
        nameSource
        classification {
          ...ClassificationFields
        }
      }
    }
    species: sharedScientificNames(
      last: $last
      searchTerm: $speciesSearchTerm
      filter: {rank: {eq: SPECIES}}
      orderBy: $orderBy
    ) {
      nodes {
        id
        scientificName
        authorship
        status
        rank
        nameSource
        classification {
          ...ClassificationFields
        }
      }
    }
    infraspecies: sharedScientificNames(
      last: $last
      searchTerm: $infraspeciesSearchTerm
      filter: {rank: {eq: INFRASPECIES}}
      orderBy: $orderBy
    ) {
      nodes {
        id
        scientificName
        authorship
        status
        rank
        nameSource
        classification {
          ...ClassificationFields
        }
      }
    }
  }
`);
